/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvitableUserDto { 
    userId: string;
    firstName: string;
    lastName: string;
    avatarUrl: string;
    city: string;
    status: InvitableUserDto.StatusEnum;
    messageInvite?: string;
    isPending?: boolean;
    isNameAnonymous?: boolean;
}
export namespace InvitableUserDto {
    export type StatusEnum = '' | 'pending' | 'joined' | 'requested';
    export const StatusEnum = {
        Empty: '' as StatusEnum,
        Pending: 'pending' as StatusEnum,
        Joined: 'joined' as StatusEnum,
        Requested: 'requested' as StatusEnum
    };
}


